// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.tracking.RentalManagerUserTrackingWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserTrackingWebApiHandler_event,
  RentalManagerUserTrackingWebApiHandler_listing,
  RentalManagerUserTrackingWebApiHandler_log,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ListingAlias, RentalManagerUserTrackingEvent } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface EventParams {
  trackingEvent: RentalManagerUserTrackingEvent;
}
interface ListingParams {
  listingAlias: ListingAlias;
  trackingEvent: RentalManagerUserTrackingEvent;
}
interface LogParams {
  description?: string;
  id: string;
}

export interface RentalManagerUserTrackingWebApiHandler_event_Args {
  getParams: EventParams;
}

export type RentalManagerUserTrackingWebApiHandler_event_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserTrackingWebApiHandler_event_Args
>;

/**
 * Track event
 */
export const useRentalManagerUserTrackingWebApiHandler_event = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserTrackingWebApiHandler_event_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserTrackingWebApiHandler_event_Args) =>
      RentalManagerUserTrackingWebApiHandler_event(args.getParams, httpClient),
  });
};

export interface RentalManagerUserTrackingWebApiHandler_listing_Args {
  getParams: ListingParams;
}

export type RentalManagerUserTrackingWebApiHandler_listing_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserTrackingWebApiHandler_listing_Args
>;

/**
 * Track listing event
 */
export const useRentalManagerUserTrackingWebApiHandler_listing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserTrackingWebApiHandler_listing_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserTrackingWebApiHandler_listing_Args) =>
      RentalManagerUserTrackingWebApiHandler_listing(args.getParams, httpClient),
  });
};

export interface RentalManagerUserTrackingWebApiHandler_log_Args {
  getParams: LogParams;
}

export type RentalManagerUserTrackingWebApiHandler_log_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserTrackingWebApiHandler_log_Args
>;

/**
 * Log events for debugging purposes
 */
export const useRentalManagerUserTrackingWebApiHandler_log = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserTrackingWebApiHandler_log_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserTrackingWebApiHandler_log_Args) =>
      RentalManagerUserTrackingWebApiHandler_log(args.getParams, httpClient),
  });
};
